import { Form, Input, message } from "antd";
import React, { useEffect, useRef } from "react";
import rpmService from "../../../../../Services/rpmService";
import { convertUTCDate } from "../../../../../utils/convertionFunc";
import { useDispatch, useSelector } from "react-redux";
import { handleSetPatientRegistrationPayload } from "../../../../../Redux/actions/patientActions";

function AddInsuranceDetails({
  children,
  handleCancel,
  currPageView,
  handleNext,
  handlePrevious,
  currLocalMappedChronics,
}) {
  const formRef = useRef();
  const dispatch = useDispatch();
  const { registrationPayload, selectedEditPatient } = useSelector(
    (state) => state.patients,
  );
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    formRef.current.setFieldsValue({
      height: selectedEditPatient?.height,
      weight: selectedEditPatient?.weight,
      insuranceId1: selectedEditPatient?.insuranceId1,
      insuranceId2: selectedEditPatient?.insuranceId2,
      insuranceName1: selectedEditPatient?.insuranceName1,
      insuranceName2: selectedEditPatient?.insuranceName2,
      patientGroupNumber: selectedEditPatient?.patientGroupNumber,
    });
  }, [selectedEditPatient]);

  const handleInsDetailsSave = async () => {
    const {
      height,
      weight,
      insuranceId1,
      insuranceId2,
      insuranceName1,
      insuranceName2,
      patientGroupNumber,
    } = formRef.current.getFieldsValue();

    if (
      !height ||
      !weight ||
      !insuranceId1 ||
      !insuranceName1 ||
      !patientGroupNumber
    ) {
      message.error("Please fill in all mandatory fields");
      return;
    }

    const requiredConsents = [
      "PHYSICIAN_ORDER",
      "DEVICE_RESP",
      "PATIENT_DATA",
      "PROGRAM",
    ];
    const consentList =
      registrationPayload?.patientRegConsentDtlList?.length > 0
        ? registrationPayload.patientRegConsentDtlList
        : selectedEditPatient?.patientRegConsentDtlList || [];
    const providedConsents = consentList.map((c) => c.consentCode);
    const missingConsents = requiredConsents.filter(
      (c) => !providedConsents.includes(c),
    );

    if (missingConsents.length > 0) {
      message.error("Please upload all required consent forms");
      return;
    }

    const payload = {
      ...registrationPayload,
      patientChronicConditionsList: currLocalMappedChronics,
      insuranceId1,
      insuranceId2,
      insuranceName1,
      insuranceName2,
      patientGroupNumber,
      height: Number(height),
      weight: Number(weight),
    };

    dispatch(handleSetPatientRegistrationPayload(payload));
    handleNext();
  };

  return (
    <>
      <Form ref={formRef}  layout="vertical">
        <div className="w-full grid md:grid-cols-4 gap-4 grid-cols-1 md:justify-center  md:items-center my-2">
          <div className="relative">
            <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
              Height <span className="text-red-500">*</span>
            </span>
            <Form.Item name="height" className="mt-1">
              <Input placeholder="Enter" className="h-10 rounded-md" />
            </Form.Item>
          </div>
          <div className="relative">
            <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
              Weight <span className="text-red-500">*</span>
            </span>
            <Form.Item name="weight" className="mt-1">
              <Input placeholder="Enter" className="h-10 rounded-md" />
            </Form.Item>
          </div>
        </div>
        <h3 className="font-bold text-base my-3">Insurance</h3>
        <div className="w-full grid md:grid-cols-4 gap-4 grid-cols-1 md:justify-center  md:items-center">
          <div className="relative">
            <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
              Insurance Name 1 <span className="text-red-500">*</span>
            </span>
            <Form.Item name="insuranceName1" className="mt-1">
              <Input placeholder="Enter" className="h-10 rounded-md" />
            </Form.Item>
          </div>
          <div className="relative">
            <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
              ID No.1 <span className="text-red-500">*</span>
            </span>
            <Form.Item name="insuranceId1" className="mt-1">
              <Input placeholder="Enter" className="h-10 rounded-md" />
            </Form.Item>
          </div>
          <div className="relative">
            <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
              Group No <span className="text-red-500">*</span>
            </span>
            <Form.Item name="patientGroupNumber" className="mt-1">
              <Input placeholder="Enter" className="h-10 rounded-md" />
            </Form.Item>
          </div>
          <div className="relative">
            <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
              Insurance Name 2
            </span>
            <Form.Item name="insuranceName2" className="mt-1">
              <Input placeholder="Enter" className="h-10 rounded-md" />
            </Form.Item>
          </div>
          <div className="relative">
            <span className="absolute -top-1  z-10 left-3 bg-white px-1 text-[#A0A2A3] text-xs">
              ID No.2
            </span>
            <Form.Item name="insuranceId2" className="mt-1">
              <Input placeholder="Enter" className="h-10 rounded-md" />
            </Form.Item>
          </div>
        </div>
      </Form>

      {/* Consent Forms Section */}
      <div className="col-span-full">{children}</div>

      <div className="flex md:flex-row text-center flex-col md:items-center items-end justify-end gap-3 ">
        <button
          disabled={currPageView === 1}
          className={`${
            currPageView > 1 ? "block" : "hidden"
          } md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-md font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white`}
          onClick={handlePrevious}
        >
          Previous
        </button>
        <button
          className="md:min-w-24 w-[3rem] md:w-24  h-8 p-1 bg-brand-White rounded-md border bg-white border-brand-primaryColor font-semibold custom-button-shadow"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          className="md:min-w-24 w-[3rem]  md:w-24  h-8 p-1 custom_filter text-brand-White rounded-md font-semibold disabled:cursor-not-allowed disabled:opacity-50 text-white"
          onClick={handleInsDetailsSave}
        >
          Next
        </button>
      </div>
    </>
  );
}

export default AddInsuranceDetails;
